import subjects from './subjects';

const conditionals = {
  subjects
};

export default conditionals;
